import { AssignAttachmentDTO } from '../models/AssignAttachment'
import { TicketRepository } from '../repositories/TicketRepository'

export function CreateAssignAttachmentCase(ticketRepository: TicketRepository) {
  return async function ({
    ticketId,
    data
  }: {
    ticketId: string
    data: AssignAttachmentDTO
  }) {
    return await ticketRepository.createAssignAttachment({ ticketId, data })
  }
}
